export const EstadoCorreoElectronico = Object.freeze({
    EN_ESPERA: "EN_ESPERA",
    FALLIDO: "FALLIDO",
    ACEPTADO: "ACEPTADO",
    ENVIADO: "ENVIADO",
    ERROR: "ERROR"
});
